/**
 * Learn more about using TypeScript with React Navigation:
 * https://reactnavigation.org/docs/typescript/
 */
/* eslint-disable */
import { NativeStackScreenProps } from '@react-navigation/native-stack';

declare global {
	namespace ReactNavigation {
		interface RootParamList extends RootStackParamList {}
	}
}

export type RootStackParamList = {
	Register: undefined;
	RegisterWithLink: {
		code: string;
		email: string;
	};
	Login:
		| undefined
		| {
				passwordReset: 'success';
		  };
	ForgotPassword: undefined;
	ResetPassword: { code: string };
	SetFirstPassword: { code: string; from?: 'web' | 'app' };
	WebContent: { uri: string; title: string };
};

export type RootStackScreenProps<Screen extends keyof RootStackParamList> = NativeStackScreenProps<
	RootStackParamList,
	Screen
>;
